import React from 'react'
import AsyncSelect from 'react-select/async'

import ProviderService from '../services/ProviderService'

const ProviderAutocomplete = React.forwardRef(
  ({ value, type, onChange, onProviderSelect, placeholder, filter }, ref) => {
    const selectedOption = value ? { label: value, value } : null

    const loadOptions = (inputValue, callback) => {
      if (!inputValue && !type && !filter) {
        // eslint-disable-next-line n/no-callback-literal
        callback([])
        return
      }
      ProviderService.search({ searchText: inputValue, type, page: 1, take: 20, ...filter })
        .then(data => {
          const options = data.results.map(p => {
            let label = ''
            if (p.isIndividual) {
              const parts = [
                p.name + (p.suffix ? `, ${p.suffix}` : '') + (p.specialties ? `, ${p.specialties}` : ''),
                p.organization,
                p.address,
              ].filter(Boolean)
              label = parts.join(' | ')
            } else {
              const parts = [p.organization || p.name, p.specialties, p.address].filter(Boolean)
              label = parts.join(' | ')
            }
            return {
              label,
              value: p.name || p.organization,
              data: p,
            }
          })
          // eslint-disable-next-line n/no-callback-literal
          callback(options)
        })
        .catch(() => callback([])) // eslint-disable-line n/no-callback-literal
    }

    const handleChange = option => {
      if (option) {
        // option.value will be the name
        onChange(option.value)

        if (onProviderSelect) {
          onProviderSelect(option.data || null)
        }
      } else {
        onChange('')
        if (onProviderSelect) {
          onProviderSelect(null)
        }
      }
    }

    return (
      <AsyncSelect
        ref={ref}
        key={filter ? JSON.stringify(filter) : 'default'}
        cacheOptions={filter ? JSON.stringify(filter) : true}
        loadOptions={loadOptions}
        defaultOptions
        value={selectedOption}
        onChange={handleChange}
        placeholder={placeholder || 'Search for Individual Providers or Organizations...'}
        isClearable
        styles={{
          control: provided => ({
            ...provided,
            borderColor: '#ced4da',
            minHeight: '38px',
          }),
          menu: provided => ({
            ...provided,
            zIndex: 9999,
          }),
        }}
      />
    )
  },
)

export default ProviderAutocomplete
